import client from './client'

export default {
  // getCustomerItem: (year: string, pagenum: string) => {
  //   return new Promise((resolve, reject) => {
  //     client.get('http://192.168.24.76/api/customer/', { params: { page: pagenum, visit_date: year } })
  //       .then(res => resolve({ count: res.data.count, results: res.data.results }))
  //       .catch(err => {
  //         reject(new Error(err.response.data.message || err.message))
  //       })
  //   })
  // },
  getCustomerItem: (year, month) => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/customer/', { params: { y: year, m: month } })
        .then(res => resolve({ count: res.data.count, results: res.data.results }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },

  getLatestCustomerItem: (x) => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/customer/', { params: { page_size: x } })
        .then(res => resolve({ results: res.data.results }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },
  getCustomerInputDate: () => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/customer/')
        .then(res => resolve({ input_date: res.data.results[0]["input_date"] }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },

}

